export const SUBSCRIPTION_READ = 'subscription.read';
export const SUBSCRIPTION_WRITE = 'subscription.write';
export const INVOICE_READ = 'invoice.read';
export const HISTORY_READ = 'history.read';
export const PAYMENT_INFORMATION_WRITE = 'payment-information.write';
